import React from 'react';
import classNames from 'classnames';
import { DataRoomRFIStatus } from 'router/subrouters/DataRoom/models/DataRoomRfi';
import { useTranslation } from 'react-i18next';

import './RfiStatusTag.styles.scss';

type RfiStatusTagProps = {
  className?: string;
  status: DataRoomRFIStatus;
};

const RfiStatusTag: React.FC<RfiStatusTagProps> = (props) => {
  const { className, status } = props;

  const classes = classNames(
    'rfi-status-tag',
    `rfi-color--${status}`,
    className,
  );

  const { t } = useTranslation();

  return <span className={classes}>{t(status)}</span>;
};

export default RfiStatusTag;
